import { requestGet, requestPost } from '@/common/request';

export default {
  //微频道状态数据
  async channelMicroStatusCount(query, config) {
    return await requestGet('/channelMicro/statusCount', query, config);
  },
  //微频道待审核的列表
  async channelMicroMyApprove(query, config) {
    return await requestGet('/channelMicro/myApprove', query, config);
  },
  //微频道我管理的列表
  async channelMicroMyManager(query, config) {
    return await requestGet('/channelMicro/myManager', query, config);
  },
  //微频道操作接口
  async channelMicroStatusEvent(query, config) {
    return await requestGet('/channelMicro/statusEvent', query, config);
  },
  //查询微频道信息
  async channelMicroGetChannel(query, config) {
    return await requestGet('/channelMicro/getChannel', query, config);
  },
  //新建微频道-查询通天塔模板id列表
  async channelMicroListTowerTemplet(query, config) {
    return await requestGet('/channelMicro/listTowerTemplet', query, config);
  },
  //微频道-关联通天塔列表
  async channelMicroListTower(query, config) {
    return await requestGet('/channelMicro/listTower', query, config);
  },
  //微频道新增
  async channelMicroAddChannel(query, config) {
    return await requestPost('/channelMicro/addChannel', query, config);
  },
  //微频道 - 管理组成员删除
  async channelMicroDelMember(query, config) {
    return await requestGet('/channelMicro/delMember', query, config);
  },
  //微频道 - 管理员列表
  async channelMicroMemberList(query, config) {
    return await requestGet('/channelMicro/memberList', query, config);
  },
  //微频道 - 管理组组长变更
  async channelMicroChangeOwner(query, config) {
    return await requestGet('/channelMicro/changeOwner', query, config);
  },
  //微频道 - 管理组成员添加
  async channelMicroAddMember(query, config) {
    return await requestPost('/channelMicro/addMember', query, config);
  },
  //微频道 - 微频道审批流信息
  async channelMicroApprovalFlow(query, config) {
    return await requestGet('/channelMicro/approvalFlow', query, config);
  },
  //微频道 - 微频道我管理的列表-导出
  async channelMicroMyManagerExport(query, config) {
    return await requestGet('/channelMicro/myManagerExport', query, config);
  },
  //微频道 - 微频道我管理的列表-导出
  async statisticTree(query, config) {
    return await requestGet('/statistic/tree', query, config);
  },
  //微频道修改
  async channelMicroUpdateChannel(query, config) {
    return await requestPost('/channelMicro/updateChannel', query, config);
  },
  // 权限管理-对应角色的成员列表
  async roleMembers(data) {
    return await requestGet('/role/members', data);
  },

  // 人员配置删除接口
  async delErp(query) {
    return await requestGet('/role/delErp ', query);
  },
  // 人员配置增加接口
  async addErp(query) {
    return await requestGet('/role/addErp', query);
  },
};
